import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const LoadingBar = () => {
    const [progress, setProgress] = useState("idle"); // 'idle', 'active', or 'complete'
    const location = useLocation();

    useEffect(() => {
        // Start loading
        setProgress("active");

        // Simulate partial loading (90%)
        const partialTimer = setTimeout(() => {
            setProgress("complete"); // Move to 100% and fade out
        }, 300); // YouTube-like quick initial progression

        // Clean up after completion
        const finishTimer = setTimeout(() => {
            setProgress("idle"); // Reset state to hide the bar
        }, 600); // Allow time for fade-out animation

        return () => {
            clearTimeout(partialTimer);
            clearTimeout(finishTimer);
        };
    }, [location]);

    return <div className={`loading-bar ${progress}`} />;
};

export default LoadingBar;
